import { render, staticRenderFns } from "./PrintBtn.vue?vue&type=template&id=1661d672&scoped=true"
import script from "./PrintBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintBtn.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PrintBtn.vue?vue&type=style&index=0&id=1661d672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1661d672",
  null
  
)

export default component.exports